import { useEffect, useState } from 'react';
import styled from 'styled-components';
import DefaultLayout from '../components/molecules/common/DefaultLayout'
import { useBack } from '../hooks/useBack';
import LabeledInput from '../components/molecules/LabeledInput';
import Text from '../components/atoms/Text';
import MainButton from '../components/atoms/MainButton';
import { useNavigate, useParams } from 'react-router-dom';
import { getWord, updateWord } from '../api/word';

const Wrapper = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  position: relative;
`
const MeaningWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  gap: 8px;
`
const ButtonWrapper = styled.div`
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 600px;
  padding: 0 16px;  
`

const WordEdit = () => {
  const navigate = useNavigate();
  const goBack = useBack(); // 뒤로가기 훅 호출

  const { id } = useParams();
  const [wordInfo, setWordInfo] = useState({ word: '', meaning: '' });
  
  useEffect(() => {
      const fetchWord = async() => {
        try {
          const wordData = await getWord(id);
          setWordInfo({
            word: wordData.kr_transcript,
            meaning: wordData.meaning
          })
          // console.log(wordData)
        } catch (err) {
          console.error(err);
        }
      };
      fetchWord();
    }, []);
  
  const handleMeaning = (e) => {
    setWordInfo(prev => ({ ...prev, meaning: e.target.value }));
  };

  const isDisabled = wordInfo.meaning.trim() === '';
  
  const handleSubmit = async() => {
    try {
      const updated = await updateWord(id, {meaning: wordInfo.meaning});
      console.log('수정 완료:', updated);
      navigate(`/words/${id}`, { replace: true })
    } catch (err) {
      console.error(err);
      alert('오류가 발생했습니다. 다시 시도해주세요.');
    }
  }
  return (
    <DefaultLayout
      headerType="sub" 
      onBack={goBack}>
      <Wrapper>
        <LabeledInput 
          label="발화내용" 
          value={wordInfo.word}
          required={true}
          readOnly={true}/>
        <MeaningWrapper>
          <LabeledInput 
            label="의미단어" 
            value={wordInfo.meaning} 
            required={true}
            onChange={handleMeaning}/>
          <Text variant="caption" color="alternative">
            오타가 있는 경우에만 수정해주세요.
          </Text>
        </MeaningWrapper>
        <ButtonWrapper>
          <MainButton 
            variant="primary"
            title="저장"
            disabled={isDisabled}
            onClick={handleSubmit}/>
        </ButtonWrapper>
      </Wrapper>
    </DefaultLayout>
  )
}

export default WordEdit
